import { cn } from "../../lib/utils"

interface LandingMicroFooterDividerProps {
  className?: string
}

export function LandingMicroFooterDivider({ className }: LandingMicroFooterDividerProps) {
  return <div className={cn("h-[0.92rem] w-px bg-white/20 transform -skew-x-16", className)} />
}
